export const fmt = (n, dec = 0) => {
  const v = Number(n);
  if (!isFinite(v)) return "0";
  return v.toLocaleString("it-IT", {
    minimumFractionDigits: dec,
    maximumFractionDigits: dec,
  });
};

export const clampNum = (v) => {
  const n = parseFloat(v);
  return isFinite(n) ? n : 0;
};
